/** @jsx jsx */
import { jsx, InterpolationWithTheme } from '@emotion/core';
import React from 'react';
import WalletButton, { useWalletButton } from 'components/WalletButton';
import styles from './styles';
import { Theme } from 'features/Theme';

interface PropTypes {
  storeNumber: string | null;
  containerStyles: InterpolationWithTheme<Theme>;
  buttonContainerStyle: InterpolationWithTheme<Theme>;
  virtualCardAccountNumber: string | undefined;
}

const TemporaryWallets: React.FC<PropTypes> = props => {
  const walletButton = useWalletButton();
  const {
    containerStyles,
    virtualCardAccountNumber,
    buttonContainerStyle,
    storeNumber,
  } = props;

  if (!virtualCardAccountNumber || !walletButton.hasWalletButton) {
    return null;
  }

  return (
    <div css={containerStyles}>
      {walletButton.hasAppleButton && (
        <div css={buttonContainerStyle}>
          <WalletButton
            css={styles.walletButton}
            storeNumber={storeNumber}
            vendor="apple"
          />
        </div>
      )}
      {walletButton.hasGoogleButton && (
        <div css={buttonContainerStyle}>
          <WalletButton
            css={styles.walletButton}
            storeNumber={storeNumber}
            vendor="google"
          />
        </div>
      )}
    </div>
  );
};

export default TemporaryWallets;
